export default "__VITE_ASSET__50uZzMDuKmRebB_W5Jz06w__"